import React from 'react';
import { css } from 'styled-components';
import { Box, Container, createComponent, getComponentVariant } from '@goodrx/matisse-react';
import { mediaMaxWidth } from '../../utils';
import { MarkdownCopy } from '../MarkdownCopy';
const StyledSection = createComponent({
  name: 'Section',
  as: Box,
  style: ({
    theme,
    variant,
    alternate,
    collapsed,
    skinny,
    extraSkinny,
    tabletDividerColor,
    mobileDividerColor,
    tabletBackgroundColor,
    mobileBackgroundColor
  }) => {
    const variantStyles = variant && getComponentVariant(theme, 'Section', variant);
    return css`
      padding: 64px 0;
      display: block;
      overflow: hidden;
      ${alternate && css`
        background: ${theme.colors.greyLightest};
      `}

      ${collapsed && css`
        padding: 0px;
      `}

      ${skinny && css`
        max-width: 600px;
        margin: 0 auto;
      `}

      ${extraSkinny && css`
        max-width: 420px;
        margin: 0 auto;
      `}

      ${mediaMaxWidth({
      md: !collapsed && css`
            padding: 24px 0;
          `
    })}

      ${mediaMaxWidth({
      md: mobileBackgroundColor && css`
            background-color: ${mobileBackgroundColor} !important;
          `
    })}

      ${mediaMaxWidth({
      md: mobileDividerColor ? css`
              border-bottom: 1px solid ${mobileDividerColor} !important;
            ` : css`
              border-bottom: none !important;
            `
    })}

      ${tabletBackgroundColor && `background-color: ${tabletBackgroundColor};`}
      ${tabletDividerColor && `border-bottom: 1px solid ${tabletDividerColor};`}

      ${variantStyles}
    `;
  }
});
const StyledSectionHeader = createComponent({
  name: 'SectionHeader',
  style: ({
    standalone,
    mobileHeaderAlignment
  }) => css`
    font-weight: 700;
    margin-bottom: ${standalone ? 0 : 40}px;
    text-align: center;

    ${mediaMaxWidth({
    md: css`
        text-align: ${mobileHeaderAlignment};
        margin-bottom: ${standalone ? 0 : 20}px;
      `
  })};
  `
});
export const Section = ({
  children,
  fluid,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(StyledSection, props, /*#__PURE__*/React.createElement(Container, {
    fluid: fluid
  }, children));
};
export const SectionHeader = ({
  title,
  subtitle,
  subsubtitle,
  standalone = false,
  mobileHeaderAlignment = 'center'
}) => {
  return /*#__PURE__*/React.createElement(StyledSectionHeader, {
    standalone: standalone,
    mobileHeaderAlignment: mobileHeaderAlignment
  }, /*#__PURE__*/React.createElement("h2", null, title), subtitle, subsubtitle && /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement(MarkdownCopy, {
    source: subsubtitle
  })));
};